import {Cookie} from '@config/cookies';
import {NextHeaders} from '@config/headers';
import {AppLocale, DEFAULT_LOCALE, locales} from '@config/locales';
import {getCookies} from './getCookies';
import {getHeaders} from './getHeaders';
import {getIsServer} from './getIsServer';

export const getLocale = async () => {
    const locale = (await getCookies()).get(Cookie.LOCALE)?.value as AppLocale;
    if (getIsServer()) {
        const localeFromHeader = (await getHeaders()).get(
            NextHeaders.LOCALE,
        ) as AppLocale;
        return localeFromHeader || locale || DEFAULT_LOCALE;
    }

    if (!locale) {
        const pathname = window.location.pathname;
        const localeFromPathname = locales.find(
            locale =>
                pathname.startsWith(`/${locale}/`) || pathname === `/${locale}`,
        );
        return localeFromPathname || DEFAULT_LOCALE;
    }

    return locale;
};
